import React from 'react'
import { graphql } from 'gatsby'

import type { Paragraph, ParagraphComponent } from '../types'
import type { DrupalMedia } from '../../Media'

import { classNames } from '../../ui/utils'
import ConditionalWrap from '../../ui/ConditionalWrap'
import Container from '../../Container'
import Media from '../../Media'

export interface MediaParagraph extends Paragraph {
	field_title: string
	fullscreen: boolean
	relationships: {
		field_media: DrupalMedia
	}
}

const MediaParagraphComponent: ParagraphComponent<MediaParagraph> = ({ className, paragraph, ...props }) => (
	<div className={classNames(className, 'text-align-center')}>
		<ConditionalWrap condition={!paragraph.fullscreen} wrap={(children) => <Container>{children}</Container>}>
			<Media source={paragraph.relationships.field_media} title={paragraph.field_title} />
		</ConditionalWrap>
	</div>
)

export default MediaParagraphComponent

export const query = graphql`
	fragment MediaParagraph on paragraph__media {
		drupal_internal__id
		field_title
		fullscreen: field_boolean
		relationships {
			field_media {
				__typename
				... on media__video {
					...MediaVideo
				}
				... on media__image {
					...MediaImage
				}
			}
		}
	}
`
